module.exports = __webpack_public_path__ + "static/media/slide-1.a0a9cab5.jpg";